import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, TextField, Typography } from '@mui/material';
import DataTable from 'components/DataTable';
import { fetchArray } from 'entity';
import Cliente from 'entity/Cliente';
import Fazenda from 'entity/Fazenda'
import { ColumnActions } from 'entity/Fazenda/functions';
import React, { useEffect, useState } from 'react'
import { usePerfil } from 'useAuth';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DialogAction from '../DialogAction';
import { useAppContext } from 'app/AppContext';
import { useNavigate } from 'react-router-dom';
import { DebugConsoleResult } from './debugg'

export default function FazendaConsulta() {
    const { useSetTitle, setActionsView } = useAppContext();
    useSetTitle('Fazendas')
    const navigate = useNavigate();
    const [uidClientes, setUidClientes] = useState(null)
    const [fazendas, setFazendas] = useState([])
    const [fazendasFilter, setFazendasFilter] = useState([])
    const perfil = usePerfil();
    let tipoPerfil = 'cliente'

    const [loading, setLoading] = useState([])
    const [searchFazenda, setSearchFazenda] = useState("")
    const [searchCliente, setSearchCliente] = useState("")
    const [searchCodigoFazenda, setSearchCodigoFazenda] = useState("")
    const [open, setOpen] = useState(false)
    const [rowToModify, setRowToModify] = useState(null)

    const onChangeSearchFazenda = e => setSearchFazenda(e.target.value)
    const onChangeSearchCliente = e => setSearchCliente(e.target.value)
    const onChangeSearchCodigoFazenda = e => setSearchCodigoFazenda(e.target.value)

    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/_fazenda");
                },
            },
        ];
        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
        // eslint-disable-next-line no-sparse-arrays
    }, [navigate, , setActionsView]);

    const handleSearch = () => {
        let filteredList
        if (fazendas && fazendas.length) {
            filteredList = fazendas.filter(fazenda => {
                let nomeFazenda = false, cliente = false, codigoFazenda = false

                if (fazenda.nomeFazenda?.toUpperCase().includes(searchFazenda.toUpperCase()))
                    nomeFazenda = true
                if (fazenda.cliente?.nome.toUpperCase().includes(searchCliente.toUpperCase()))
                    cliente = true
                if (fazenda.codFazenda?.toUpperCase().includes(searchCodigoFazenda.toUpperCase()))
                    codigoFazenda = true

                return nomeFazenda && cliente && codigoFazenda
            })
        }

        if (filteredList && filteredList.length) {
            setFazendasFilter(filteredList)
        } else if (filteredList && filteredList.length === 0) {
            setFazendasFilter([])
        }
    }

    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    useEffect(() => {
        const busca = async () => {
            console.log('busca clientes')

            let uidClientesPermitidos = [];

            if (tipoPerfil === 'lider') {
                if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                    uidClientesPermitidos = perfil.clientesPermitidos.map(c => c.uid);
                }
            } else { // para técnico
                let query = Cliente.collection.where('perfisAutorizado.' + perfil.uid, '==', true);
                const result = await fetchArray(query.get());
                uidClientesPermitidos = result.map(c => c.uid);
            }

            setUidClientes(uidClientesPermitidos);
        }
        if (perfil && tipoPerfil !== 'admin') {
            busca()
        }

        return () => { }
    }, [perfil, tipoPerfil])

    const extraQuery = (col) => {
        if (perfil) {
            if (uidClientes) {
                if (uidClientes.length)
                    if (uidClientes.length <= 10)
                        col = col.where('cliente.uid', 'in', uidClientes)
            } else
                if (perfil && tipoPerfil !== 'admin')
                    col = col.where('uid', '==', '')
        } else
            col = col.where('uid', '==', '')
        return col
    }

    useEffect(() => {
        let observer = null
        setLoading(true)

        observer = extraQuery(Fazenda.collection.where("status", "==", "ATIVO"))
            .onSnapshot(snap => {
                let resultFazendas = []
                snap.forEach(doc => resultFazendas.push(doc.data()))
                setFazendas(resultFazendas)

                setFazendasFilter(resultFazendas)
                handleSearch()
                setLoading(false)
            })
        return () => {
            if (observer) observer()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perfil, uidClientes])

    const removeItem = (row) => {
        let ItemIndexFilter = fazendasFilter.map(faz => faz.uid).indexOf(row.uid)
        fazendasFilter.splice(ItemIndexFilter, 1)
        setFazendasFilter([...fazendasFilter])

        let ItemIndexFullList = fazendas.map(faz => faz.uid).indexOf(row.uid)
        fazendas.splice(ItemIndexFullList, 1)
        setFazendas([...fazendas])

        let entity = new Fazenda()
        entity.update({ uid: row.uid, status: 'INATIVO' });

        entity.save().then(() => {
            console.log('salvou reuniao')
            handleSearch()
        })
    }

    return (
        <>
            <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
                <Box sx={{ textAlign: "center", mt: 0 }}>
                    <Accordion sx={{ boxShadow: 3, mb: 1 }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography><b>Filtros</b></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <DebugConsoleResult values={fazendasFilter} />
                            <TextField
                                sx={{ width: "100%", my: 2 }}
                                id="clienteSearchTextField"
                                label="Cliente"
                                variant="standard"
                                onChange={onChangeSearchCliente}
                                value={searchCliente}
                                onKeyUp={() => handleSearch()}
                            />
                            <TextField
                                sx={{ width: "100%", my: 2 }}
                                id="codigoFazendaSearchTextField"
                                label="Código da Fazenda"
                                variant="standard"
                                onChange={onChangeSearchCodigoFazenda}
                                value={searchCodigoFazenda}
                                onKeyUp={() => handleSearch()}
                            />
                            <TextField
                                sx={{ width: "100%", my: 2 }}
                                id="fazendaSearchTextField"
                                label="Fazenda"
                                variant="standard"
                                onChange={onChangeSearchFazenda}
                                value={searchFazenda}
                                onKeyUp={() => handleSearch()}
                            />
                        </AccordionDetails>
                    </Accordion>
                </Box>

                {loading
                    ? <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '5em' }}>
                        <CircularProgress />
                    </div>
                    : fazendasFilter && fazendasFilter.length
                        ? <DataTable
                            columns={[
                                {
                                    field: "COL_EDIT", headerName: "Ações", flex: 0.8, renderCellValue: (row) => (
                                        <ColumnActions row={row} open={open} setOpen={setOpen} setRowToModify={setRowToModify} />
                                    )
                                },
                                { field: "cliente.nome", headerName: "Cliente", flex: 2, filter: true },
                                { field: "codFazenda", headerName: "Cód. Fazenda", flex: 1, filter: true },
                                { field: "nomeFazenda", headerName: "Nome Fazenda", flex: 2, filter: true },
                                { field: "areaTotalFazenda", headerName: "Área Total", flex: 1 },
                            ]}
                            rows={fazendasFilter}
                            autoHeight
                            loading={loading}
                            sx={{ "& .MuiDataGrid-row:hover": { cursor: "pointer" } }}
                        />
                        : <Typography sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: '5em' }} variant="h6">
                            - NENHUMA FAZENDA -
                        </Typography>
                }
                <DialogAction open={open} setOpen={setOpen} statusCb={removeItem} row={rowToModify} />
            </Box>
        </>
    )
}
